/* ---------------------------------------------------------
   SALEEQA CUSTOM SCRIPTS
   --------------------------------------------------------- */

(function () {
  'use strict';

  /* ---------------------------------------------------------
     Product section height

     Prestige positions the product info column out of normal
     flow, so .Product__Wrapper takes its height from the
     gallery alone. Opening an accordion then overflows into
     the following section.

     We measure the lowest point of every child and set a
     matching min-height on the wrapper. Measuring the wrapper's
     immediate children is not enough on its own, because
     .Product__InfoWrapper is static while .Product__Info inside
     it is the positioned element, so the outer one reports
     almost no height.
     --------------------------------------------------------- */

  function fitProductSection() {
    var wrap = document.querySelector('.Product__Wrapper');
    if (!wrap) return;

    wrap.style.minHeight = '';

    /* Columns stack below this width, so the browser handles it */
    if (window.innerWidth < 1008) return;

    var wrapTop = wrap.getBoundingClientRect().top;
    var lowest = wrapTop;

    var parts = wrap.querySelectorAll(
      '.Product__Gallery, .Product__InfoWrapper, .Product__Info, .Product__Info > .Container, .Product__Aside'
    );

    Array.prototype.forEach.call(parts, function (el) {
      var bottom = el.getBoundingClientRect().bottom;
      if (bottom > lowest) lowest = bottom;
    });

    var needed = Math.ceil(lowest - wrapTop);

    if (needed > wrap.offsetHeight) {
      wrap.style.minHeight = needed + 'px';
    }
  }

  /* ---------------------------------------------------------
     Trust line beneath the buy area on product pages

     Single caption line rather than a list, so it reads as a
     note on the button rather than a content block. Appended to
     the end of the product form so third party buttons injected
     later (back in stock) cannot land underneath it.
     --------------------------------------------------------- */

  function placeTrustLine() {
    if (document.body.className.indexOf('template-product') === -1) return;

    var form = document.querySelector('.ProductForm');
    if (!form) {
      var atc = document.querySelector('.ProductForm__AddToCart');
      if (atc) form = atc.closest('form') || atc.parentNode;
    }
    if (!form) return;

    var el = document.querySelector('.SlqaTrust');

    if (!el) {
      el = document.createElement('p');
      el.className = 'SlqaTrust';
      el.innerHTML =
        'Free UK shipping' +
        '<span aria-hidden="true">&middot;</span>' +
        'Duties covered' +
        '<span aria-hidden="true">&middot;</span>' +
        '14-day returns';
    }

    /* Always move it to the end, even if something was added after */
    if (el.parentNode !== form || form.lastElementChild !== el) {
      form.appendChild(el);
    }

    fitProductSection();
  }

  function watchBuyArea() {
    if (document.body.className.indexOf('template-product') === -1) return;
    if (!('MutationObserver' in window)) return;

    var form = document.querySelector('.ProductForm');
    if (!form) return;

    var pending = null;
    var mo = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(placeTrustLine, 120);
    });

    mo.observe(form, { childList: true });
  }

  window.addEventListener('load', function () {
    placeTrustLine();
    watchBuyArea();
    fitProductSection();
  });

  window.addEventListener('resize', fitProductSection);

  /* <details> toggle does not bubble, so listen in the capture phase */
  document.addEventListener('toggle', function (event) {
    if (event.target && event.target.tagName === 'DETAILS') {
      setTimeout(fitProductSection, 60);
      setTimeout(fitProductSection, 320);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(placeTrustLine, 300);
    setTimeout(placeTrustLine, 900);
    setTimeout(placeTrustLine, 2000);
    setTimeout(fitProductSection, 400);
    setTimeout(fitProductSection, 1200);
    setTimeout(fitProductSection, 2500);
  });
})();
